import React from 'react';
import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import RiskForm from './RiskForm';
import useRiskService from '../useRiskService';
import { useProjectId } from 'domain/shared/project';
import { useNewProjectUrl } from 'domain/shared/newProject';
import { useNavigate } from 'react-router-dom';

const CreateRiskLayout = () => {
  const { getRisksValidationSchema, createRisk } = useRiskService();
  const id = useProjectId();
  const { getRisksUrl } = useNewProjectUrl();
  const navigate = useNavigate();

  return (
    <CreateForm
      submitFormFunc={async values => {
        const response = await createRisk(id, {
          id: values?.id,
          title: values?.title,
          description: values?.description,
          type: values?.type,
          probability: values?.probability,
          severity: values?.severity,
          riskOwner: values?.riskOwner,
          status: values?.status,
          mitigationStrategy: values?.mitigationStrategy,
          isIncludedInCustomerReport: values?.isIncludedInCustomerReport,
        });
        return { result: response };
      }}
      afterSubmit={{
        redirect: getRisksUrl(id),
        message: 'You are awesome! The Risk has been successfully created.',
      }}
      getDataFunc={() => Promise.resolve()}
      getValidationSchemaFunc={getRisksValidationSchema}
    >
      <CreatePageLayout isCancelButtonVisible={false} title="Create Risk:" buttons={<></>}>
        <RiskForm onCancelAction={() => navigate(getRisksUrl(id))} />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateRiskLayout;
